module.exports = "/_next/static/images/62344de4d74566a9b101476253606406-product-information-lg-1x.jpg.webp";